import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Typography, makeStyles, useMediaQuery } from '@ellucian/react-design-system/core';
import { useTheme } from '@mui/material';
const useStyles = makeStyles(() => ({
    root: {
        textAlign: 'center',
        marginBottom: '4rem'
    },
}));
const desktopImage = 'https://cdn.elluciancloud.com/assets/EDS2/4.0.0/img/illustrations/large/403.png';
const mobileImage = 'https://cdn.elluciancloud.com/assets/EDS2/4.0.0/img/illustrations/large/403Narrow.png';
const Illustration = () => {
    const intl = useIntl();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const imgSrc = useMemo(() => isMobile ? mobileImage : desktopImage, [isMobile]);
    return <img alt={intl.formatMessage({ id: 'shareUrlAccessErrorImgAlt' })} src={imgSrc} />;
};

const IllustrationWrapper = Illustration;

const InvalidShareUrl = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <IllustrationWrapper />
            <Typography variant="h1">
                <FormattedMessage id="archivedInquiryFormAccessMessageTextId" />
            </Typography>
        </div>
    );
};

export default InvalidShareUrl;
